import { observable, computed, action, asFlat } from 'mobx'
import { getAnswerPageReports } from 'common/api'

class Report {
  @observable id = 0                // 题目 id
  @observable name = ''             // 题目 name
  @observable category = ''         // 题目类型: radio | multi | blank | speaking | writing
  @observable material = {          // 材料
    text: asFlat([]),
    picture: '',
    audio: ''
  }
  @observable tipId = 0             //逐题精讲
  @observable additionMaterial = asFlat({})     // 补充材料
  @observable detail = asFlat([])           // 题目详情
  @observable userAnswer = asFlat([])       // 用户答案
  @observable isCorrect = false             // 是否正确
  @observable sliceInfo = {}                //逐题精讲

  constructor (data) {
    this.id = data.id
    this.name = data.name
    this.category = data.category
    this.material = data.material
    this.detail = data.detail
    this.userAnswer = data.userAnswer
    this.isCorrect = data.isCorrect
    this.additionMaterial = data.additionMaterial
    this.sliceInfo = data.sliceInfo
    this.tipId = data.tipId
    this.reportStatus = data.reportStatus
    this.answerId = data.answerId
  }

  @computed get isSingleLayout () {
    if (this.category === 'writing') { return false }
    if (this.category === 'speaking') { return true }

    const hasMaterial = this.material.text.length || this.material.picture || this.material.audio
    const onlyHasAudio = !this.material.text.length && !this.material.picture && this.material.audio

    return !hasMaterial || onlyHasAudio
  }

  @computed get canPigai () {
    return this.category === 'speaking' || this.category === 'writing'
  }
}

export default class Answer {
  @observable list = []                   // 列表
  @observable timeCost = 0                // 耗费时间
  @observable idx = 0                     // 当前报告 idx
  @observable show = {
    askTeacher: false,                    // 问问老师
    loading: false,                       // loading 数据
    pigai: false,                          // 预约批改
    correction: false                       //显示我要纠错
  }
  @observable userGroup                     // 用户中心所在分组，用于区分是否是 inside 用户
  @observable userGroupName                     // 用户中心所在分组，用于区分是否是 inside 用户

  @computed get correctList () {
    return this.list.map(item => item.isCorrect)
  }

  @computed get currentReport () {
    return this.list.length ? this.list[this.idx] : null
  }

  @action fetchData (exerciseId) {
    this.show.loading = true

    return getAnswerPageReports(exerciseId)
      .then(action('fetchData end', data => {
        this.list = data.answer.map(item => new Report(item))
        this.show.loading = false
        this.timeCost = data.time
        this.userGroup = data.userGroup
        this.userGroupName = data.userGroupName
      }))
  }

  @action changeReport (idx) {
    this.idx = idx
  }

  @action toggleAskTeacher (show) {
    this.show.askTeacher = show
  }

  @action togglePigai (show) {
    this.show.pigai = show
  }

  @action toggleLogin (show) {
    this.show.login = show
  }

  @action showCorrection (show) {
    this.show.correction = show
  }
}



/** WEBPACK FOOTER **
 ** ./src/models/Answer.js
 **/